import {
  BulkStatus,
  IBulkPayrollBatch
} from "@wingspanhq/payments/dist/interfaces";
import { WSService } from "../utils/WSService";

const service = new WSService("/payments/bulk/payroll/batch");

export type ApiQueryListBulkPayrollBatches = {
  "filter[status][=]"?: BulkStatus;
  "filter[status][in]"?: BulkStatus[];
};

export async function listBulkPayrollBatches(
  query?: ApiQueryListBulkPayrollBatches
): Promise<IBulkPayrollBatch[]> {
  const { data } = await service.get("", { params: query });
  return data;
}
